export const setBaseDate = date => ({ type: 'SET_BASE_DATE', date })

export const setTimeline = timeline => ({ type: 'SET_TIMELINE', timeline })

export const setLoadedEvents = events => ({ type: 'SET_EVENTS', events })

export const updateEvents = events => ({ type: 'EVENTS_UPDATED', events })

export const createEvents = events => ({ type: 'EVENTS_CREATED', events })

export const setSelectedCount = count => ({ type: 'SET_EVENT_SELECTED_COUNT', count })

export const setCopiedEvents = (events, baseDate) => ({ type: 'SET_COPIED_EVENTS', events, baseDate })
